import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button, ScrollView } from "devextreme-react";
import UserInfo from "../../UserInfo";
import {
  criarNotificacaoDiatDs,
  criarContribuinteDs,
  criarTipoNotificacaoDs,
  criarReceitasDs,
} from "../../DataSources";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import apiAxios from "../../api-axios";
//import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  contribuinteId: undefined,
  tipoId: undefined,
  receitaId: undefined,
  valorMinimo: undefined,
  valorMaximo: undefined,
  exercicioMinimo: undefined,
  exercicioMaximo: undefined,
  debitosExercicioInicio: undefined,
  debitosExercicioFim: undefined,
  renotificar: false,
  popupVisivel: false,
  _uiContribuinteId: undefined,
};

export default class NotificacaoDiatForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...(_cadastroCorrente || template),
      popupVisivel: false,
    };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.notificacaoDiatDs = criarNotificacaoDiatDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.setNomeContribuinte = this.setNomeContribuinte.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa = this.onContribuinteSelecionadoPesquisa.bind(
      this
    );
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state._uiContribuinteId,
      this.setContribuinteId,
      () => this.state._uiNomeContribuinte,
      this.pesquisarContribuinte
    );
    this.setNomeContribuinte = this.setNomeContribuinte.bind(this);
    this.atualizarNomeContribuinte = this.atualizarNomeContribuinte.bind(this);
  }

  setContribuinteId(data) {
    this.setState({
      _uiContribuinteId: data.value,
      contribuinteId: parseInt(data.value),
    });
    this.atualizarNomeContribuinte();
  }

  atualizarNomeContribuinte() {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.contribuinteId]] })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setNomeContribuinte(result[0]);
        } else {
          this.setNomeContribuinte(undefined);
        }
      })
      .catch((_) => this.setNomeContribuinteErro());
  }

  setNomeContribuinte(contribuinte) {
    if (contribuinte === undefined) {
      this.setState({ _uiNomeContribuinte: "" });
    } else {
      this.setState({ _uiNomeContribuinte: contribuinte.nome });
    }
  }

  setNomeContribuinteErro() {
    this.setState({ _uiNomeContribuinte: "<<ERRO>>" });
  }

  onContribuinteSelecionadoPesquisa(e) {
    this.setState({
      contribuinteId: e.row.data.sequencial,
      _uiContribuinteId: e.row.data.sequencial.toString(),
      popupVisivel: false,
    });
    this.atualizarNomeContribuinte();
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupVisivel: true });
  }

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      this.setState({ ..._cadastroCorrente });
    } else {
      this.setState({ ...template });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    this.contribuinteDs = criarContribuinteDs();

    const tipoReceitaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarReceitasDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };

    const tipoNotificacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarTipoNotificacaoDs(),
      valueExpr: "id",
      displayExpr: "tipo",
    };

    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form>
          <Form formData={this.state} colCount={2}>
            <GroupItem
              caption="Filtros para Gerar Notificação de Dívida Ativa"
              colSpan={2}
              colCount={2}
            >
              <SimpleItem colSpan={2} component={this.renderContribuinte}>
                <Label text="Contribuinte" />
              </SimpleItem>
              <SimpleItem
                colSpan={1}
                dataField={"receitaId"}
                editorType={"dxLookup"}
                editorOptions={tipoReceitaOptions}
              >
                <Label text="Receita" />
              </SimpleItem>
              <SimpleItem
                colSpan={1}
                dataField={"tipoId"}
                editorType={"dxLookup"}
                editorOptions={tipoNotificacaoOptions}
              >
                <Label text="Tipo de Notificação" />
              </SimpleItem>
              <SimpleItem
                dataField={"valorMinimo"}
                editorType={"dxNumberBox"}
                cssClass={"box-n2"}
                editorOptions={{
                  step: 0,
                  format: { type: "fixedPoint", precision: 2 },
                }}
              >
                <Label text="Valor Total Mínimo (R$)" />
              </SimpleItem>
              <SimpleItem
                dataField={"valorMaximo"}
                editorType={"dxNumberBox"}
                cssClass={"box-n2"}
                editorOptions={{
                  step: 0,
                  format: { type: "fixedPoint", precision: 2 },
                }}
              >
                <Label text="Valor Total Máximo (R$)" />
              </SimpleItem>
              <SimpleItem
                dataField={"exercicioMinimo"}
                editorType={"dxNumberBox"}
                editorOptions={{ value: null }}
              >
                <Label text="Menor Exercício" />
              </SimpleItem>
              <SimpleItem
                dataField={"exercicioMaximo"}
                editorType={"dxNumberBox"}
                editorOptions={{ value: null }}
              >
                <Label text="Maior Exercício" />
              </SimpleItem>
              <SimpleItem
                dataField={"debitosExercicioInicio"}
                editorType={"dxNumberBox"}
                editorOptions={{ value: null }}
              >
                <Label text="Início do Exercício dos Débitos" />
              </SimpleItem>
              <SimpleItem
                dataField={"debitosExercicioFim"}
                editorType={"dxNumberBox"}
                editorOptions={{ value: null }}
              >
                <Label text="Fim do Exercício dos Débitos" />
              </SimpleItem>
              <SimpleItem dataField={"renotificar"} editorType={"dxCheckBox"}>
                <Label text="Renotificar" />
              </SimpleItem>
            </GroupItem>
          </Form>

          <br></br>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Fechar" onClick={this.cancel} width={120} />
            </div>
          </div>
        </form>

        <Popup
          visible={this.state.popupVisivel}
          onHiding={this.hideInfo}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Contribuinte"
        >
          <ScrollView showScrollbar={"always"}>
            <ContribuinteBox
              onSelecionado={this.onContribuinteSelecionadoPesquisa}
              ref={this.contribuinteBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </div>
    );
  }

  ok() {
    const entidade = this.state;
    console.log("dto sendo enviado", entidade);
    apiAxios
      .post("/notificacaodiat/" + UserInfo.getPrefeitura(), entidade)
      .then((response) => {
        _cadastroCorrente = undefined;
        _cancelando = true;
        notify(
          "Notificação de Dívida Ativa cadastrado com sucesso.",
          "success"
        );
        console.log(response);
        this.props.history.goBack();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
